import React, { useRef } from 'react';
import { Box, FormLabel, ListItemText, MenuItem, Select, Tooltip } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { useChipFit } from '@/hooks/useChipFit';
import { OverflowChips } from '@/components/OverflowChips';
import { RELATIONSHIP_CONTACT_STATUS_OPTIONS } from '@/utils/relationshipContactOptions';

export const RelationshipContactStatusSelect = ({
	disabled,
	width = '150px',
	filters,
	onFilterChange,
}) => {
	const statusFilter = filters.relationshipStatus;
	const containerRef = useRef();

	const allItems = [
		{
			label: 'Clear Filters',
			value: 'None',
			isRefined: statusFilter.length === 0,
		},
		...RELATIONSHIP_CONTACT_STATUS_OPTIONS.map((option) => ({
			...option,
			isRefined: statusFilter.includes(option.value),
		})),
	];

	const selectedOptions = RELATIONSHIP_CONTACT_STATUS_OPTIONS.filter((option) =>
		statusFilter.includes(option.value),
	);
	const selectedValues = selectedOptions.map((option) => option.value);
	const selectedLabels = selectedOptions.map((option) => option.label).join(', ');

	const limitTags = useChipFit(containerRef, selectedValues.length);

	const handleChange = (event) => {
		const values = event.target.value;

		onFilterChange({
			relationshipStatus: values.includes('None')
				? []
				: RELATIONSHIP_CONTACT_STATUS_OPTIONS.filter((option) =>
						values.includes(option.value),
					).map((option) => option.value),
		});
	};

	return (
		<Box width={width}>
			<FormLabel>{'Status'}</FormLabel>
			<Tooltip disableFocusListener title={selectedLabels} placement='bottom-start'>
				<Box ref={containerRef} sx={{ width: '100%' }}>
					<Select
						multiple
						fullWidth
						disabled={disabled}
						value={selectedValues}
						onChange={handleChange}
						sx={{
							minHeight: 35,
							display: 'flex',
							alignItems: 'center',
						}}
						renderValue={(selected) => (
							<OverflowChips
								items={selected}
								limitTags={limitTags}
								getLabel={(value) =>
									selectedOptions.find((option) => option.value === value).label
								}
							/>
						)}
					>
						{allItems.map((item) => {
							return (
								<MenuItem key={`select-${item.label}`} value={item.value}>
									{item.isRefined ? <CheckBox /> : <CheckBoxOutlineBlank />}
									<ListItemText primary={item.label} />
								</MenuItem>
							);
						})}
					</Select>
				</Box>
			</Tooltip>
		</Box>
	);
};
